const REQUIRED_FIELDS = [
  { key: 'email', label: 'user.email' },
  { key: 'accountId', label: 'account.id' },
  { key: 'accessToken', label: 'accessToken' }
]

const readText = (value) => {
  if (typeof value === 'string') {
    return value.trim()
  }

  return ''
}

const isValidEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

export const parseSessionToken = (tokenText) => {
  const text = readText(tokenText)

  if (!text) {
    return {
      ok: false,
      message: '请输入 Token JSON 数据',
      data: null
    }
  }

  let session
  try {
    session = JSON.parse(text)
  } catch (error) {
    return {
      ok: false,
      message: 'Token 不是有效的 JSON 格式',
      data: null
    }
  }

  if (!session || typeof session !== 'object' || Array.isArray(session)) {
    return {
      ok: false,
      message: 'Token JSON 必须是对象',
      data: null
    }
  }

  const data = {
    name: readText(session.user && session.user.name) || '未知',
    email: readText(session.user && session.user.email),
    accountId: readText(session.account && session.account.id),
    accessToken: readText(session.accessToken)
  }

  const missingFields = REQUIRED_FIELDS
    .filter((field) => !data[field.key])
    .map((field) => field.label)

  if (missingFields.length > 0) {
    return {
      ok: false,
      message: `Token 缺少必要字段：${missingFields.join('、')}`,
      data: null
    }
  }

  if (!isValidEmail(data.email)) {
    return {
      ok: false,
      message: 'Token 中的 user.email 格式不正确',
      data: null
    }
  }

  return {
    ok: true,
    message: '',
    data: {
      ...data,
      accountType: readText(session.account && (session.account.planType || session.account.structure)),
      expires: readText(session.expires)
    }
  }
}
